document.querySelectorAll('[data-performance-gallery]').forEach((gallery) => {
  const track = gallery.querySelector('.np-performance-gallery__track');
  const items = [...gallery.querySelectorAll('.np-performance-gallery__item')];
  const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
  const previous = gallery.querySelector('[data-gallery-previous]');
  const next = gallery.querySelector('[data-gallery-next]');
  let activeIndex = 0;
  let scrollFrame = null;

  if (!track || items.length === 0) return;

  function updateControls(index) {
    activeIndex = Math.max(0, Math.min(index, items.length - 1));
    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === activeIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
    if (previous) previous.disabled = activeIndex === 0;
    if (next) next.disabled = activeIndex === items.length - 1;
  }

  function centerItem(index, behavior = 'smooth') {
    const targetIndex = Math.max(0, Math.min(index, items.length - 1));
    const item = items[targetIndex];
    updateControls(targetIndex);

    const positionItem = () => {
      if (track.clientWidth === 0 || item.offsetWidth === 0) return;
      track.scrollTo({
        left: item.offsetLeft - ((track.clientWidth - item.offsetWidth) / 2),
        behavior,
      });
    };
    const image = item.querySelector('img');
    if (image && (!image.complete || image.naturalWidth === 0)) {
      image.addEventListener('load', () => window.requestAnimationFrame(positionItem), { once: true });
    }
    window.requestAnimationFrame(positionItem);
  }

  previous?.addEventListener('click', () => centerItem(activeIndex - 1));
  next?.addEventListener('click', () => centerItem(activeIndex + 1));
  dots.forEach((dot, index) => dot.addEventListener('click', () => centerItem(index)));

  track.addEventListener('scroll', () => {
    if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
    scrollFrame = window.requestAnimationFrame(() => {
      const center = track.scrollLeft + (track.clientWidth / 2);
      const closest = items.reduce((best, item, index) => {
        const distance = Math.abs(center - (item.offsetLeft + (item.offsetWidth / 2)));
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Number.POSITIVE_INFINITY });
      updateControls(closest.index);
    });
  }, { passive: true });

  gallery.closest('[role="tabpanel"]')?.addEventListener('np:tabshown', () => {
    window.requestAnimationFrame(() => centerItem(activeIndex, 'auto'));
  });
  window.addEventListener('load', () => centerItem(activeIndex, 'auto'), { once: true });
  window.requestAnimationFrame(() => centerItem(0, 'auto'));
});

let performanceLightbox = null;

function getPerformanceLightbox() {
  if (performanceLightbox) return performanceLightbox;
  performanceLightbox = document.createElement('dialog');
  performanceLightbox.className = 'np-gallery-lightbox';
  performanceLightbox.innerHTML = '<button type="button" class="np-gallery-lightbox__close" aria-label="Close"><i class="fa-light fa-xmark" aria-hidden="true"></i></button><figure><img alt=""><figcaption></figcaption></figure>';
  document.body.append(performanceLightbox);
  performanceLightbox.querySelector('.np-gallery-lightbox__close')?.addEventListener('click', () => performanceLightbox.close());
  performanceLightbox.addEventListener('click', (event) => {
    if (event.target === performanceLightbox) performanceLightbox.close();
  });
  return performanceLightbox;
}

document.querySelectorAll('#posts img:not(.donottouch):not(.dotouch)').forEach((image) => {
  if (image.closest('[data-gallery-image]')) return;

  const source = image.getAttribute('src');
  if (!source) return;

  const floatDirection = window.getComputedStyle(image).float === 'right' ? 'right' : 'left';
  image.removeAttribute('style');
  image.classList.add('np-content-lightbox-image');
  image.dataset.float = floatDirection;

  const existingLink = image.parentElement?.matches('a') ? image.parentElement : null;
  const lightboxLink = existingLink || document.createElement('a');
  if (!existingLink) {
    image.parentNode?.insertBefore(lightboxLink, image);
    lightboxLink.append(image);
  }
  lightboxLink.href = source;
  lightboxLink.classList.add('np-content-lightbox');
  lightboxLink.dataset.galleryImage = source;
  lightboxLink.dataset.galleryTitle = image.getAttribute('alt') || image.getAttribute('title') || '';
});

document.querySelectorAll('#posts p[style]').forEach((paragraph) => {
  if (paragraph.style.getPropertyValue('text-align').trim().toLowerCase() !== 'justify') return;
  paragraph.style.removeProperty('text-align');
  if (paragraph.style.length === 0) paragraph.removeAttribute('style');
});

document.querySelectorAll('[data-gallery-image]').forEach((item) => {
  item.addEventListener('click', (event) => {
    event.preventDefault();
    const lightbox = getPerformanceLightbox();
    const image = lightbox.querySelector('img');
    const caption = lightbox.querySelector('figcaption');
    image.src = item.dataset.galleryImage;
    image.alt = item.dataset.galleryTitle || '';
    caption.textContent = item.dataset.galleryTitle || '';
    caption.hidden = !item.dataset.galleryTitle;
    lightbox.showModal();
  });
});
